import classNames from "classnames";
import * as React from "react";
import styles from "./styles.scss";

type Props = React.PropsWithChildren<{
  className?: string;
}>;

export const Body = ({ children, className }: Props) => {
  return <div className={classNames(styles.root, className)}>{children}</div>;
};
